import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion';
import { imageVariants, textVariants, containerVariants, fadeInUp, azxc, bzxc } from '../script/animationVariants';
import MagnifyingGlassComponent from '../components/MagnifyingGlassComponent';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { useTranslation } from 'react-i18next';
import { projelerData } from '../data/projeler-data';

const InnerSystemComponent = ({ data, category, id1, id2 }) => {
    const { i18n, t } = useTranslation();
    const currentLanguage = i18n.language;

    const [isLightboxOpen, setIsLightboxOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(0);

    const handleImageClick = (index) => {
        setSelectedImage(index);
        setIsLightboxOpen(true);
    };

    return (
        <motion.div
            className='bg-white customHScreen'
            initial="hidden"
            animate="visible"
            variants={containerVariants}
        >
            <div className='grid grid-cols-14'>
                <div className='col-start-2 col-span-11' >
                    <motion.div
                        variants={fadeInUp(0.2)}
                        initial="initial"
                        whileInView="animate"
                        className='mb-10 font-extralight text-2xl'
                    >
                        {data.name[currentLanguage]}
                    </motion.div>
                    <motion.div
                        variants={fadeInUp(0.4)}
                        initial="initial"
                        whileInView="animate"
                        className='mb-10 font-light text-sm w-full break-words '
                    >
                        <div className='space-y-2'>
                            {data?.text?.map((item, index) => (
                                <h5 key={index} className='block'>{item[currentLanguage]}</h5>
                            ))}
                        </div>
                        {data?.markedText &&
                            <div className='mt-10 space-y-3'>
                                <h6 className='font-light'>{data.markedText.title[currentLanguage]}</h6>
                                <div>
                                    {data.markedText.items.map((item, index) => (
                                        <h6 key={index}>{item[currentLanguage]}</h6>
                                    ))}
                                </div>
                            </div>
                        }
                    </motion.div>

                    <Lightbox
                        open={isLightboxOpen}
                        close={() => setIsLightboxOpen(false)}
                        slides={
                            data.images?.map((image) => ({
                                src: `/images/systems/${id1}${id2 ? '/' : ''}${id2 ? id2 : ''}/${image}.png`,
                                alt: ""
                            }))
                        }
                        index={selectedImage}
                        styles={{
                            container: { backgroundColor: "rgba(0, 0, 0, .9)" },
                        }}
                        render={{
                            slide: ({ slide }) => (
                                <div className="relative w-full h-full flex items-center justify-center" style={{ padding: '40px 0' }}>
                                    <div className="relative inline-block" style={{ maxWidth: '100vw', maxHeight: 'calc(100vh - 80px)' }}>
                                        <img 
                                            src={slide.src} 
                                            alt={slide.alt || ""} 
                                            className="block"
                                            style={{ maxWidth: '100vw', maxHeight: 'calc(100vh - 80px)', width: 'auto', height: 'auto' }}
                                        />
                                        <img 
                                            src="/images/filigran-square.png" 
                                            alt="" 
                                            className="absolute top-0 left-0 w-full h-full pointer-events-none"
                                            style={{ objectFit: 'contain' }}
                                        />
                                    </div>
                                </div>
                            )
                        }}
                    />

<motion.div
    initial="hidden"
    whileInView="visible"
    variants={azxc}
    className="grid grid-cols-1 md:grid-cols-2 gap-2"
>
    {data.innerCategory?.map((item, index) => {
        const isLastItem = index === data.innerCategory.length - 1;
        const isOdd = data.innerCategory.length % 2 !== 0;
        const shouldSpanTwo = isOdd && isLastItem;

        return (
            <motion.div
                key={index}
                variants={bzxc}
                className={shouldSpanTwo ? "md:col-span-2" : ""}
            >
                <Link to={item.link} key={index}>
                    <div className="cursor-pointer mb-8 group">
                        <div className='relative'>
                            <img
                                className={`${shouldSpanTwo ? "aspect-video md:aspect-[32/9] " : "aspect-video "} transition-all duration-300 object-cover w-full`}
                                src={`/images/systems/${id1}${id1 ? '/' : ''}${id2 ? id2 : ''}/${item.link}/1.png`}
                                alt={item.name[currentLanguage]}
                            />
                                     <img src='/images/filigran-rectangle.png' className='absolute top-0 left-0 w-full h-full object-cover '/> 
                            <div className='absolute top-0 left-0 bg-black z-10 h-full w-full opacity-0 group-hover:opacity-30 transition-all duration-300'></div>
                        </div>
                        <div className="w-full flex justify-between items-center font-light text-20 pt-4 pb-4 relative">
                            <h2>{item.name[currentLanguage]}</h2>
                            <div className="h-7 w-7 flex justify-center items-center relative pr-6">
                                <div className="h-px absolute w-full bg-customGray"></div>
                                <div className="h-px absolute w-full bg-customGray rotate-90"></div>
                            </div>
                            <div className="h-px w-1/3 bg-customGray absolute bottom-0 left-0"></div>
                        </div>
                    </div>
                </Link>
            </motion.div>
        );
    })}
</motion.div>

                    <div className='text-xs font-extralight mb-5 mt-20'>{t('galleryTitle')}</div>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        variants={azxc}
                        className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 mb-10'
                    >
                        {data.images.map((item, index) => (
                            <motion.div key={index} variants={bzxc}>
                                <div
                                    className='h-44 relative group overflow-hidden cursor-pointer hover:scale-150 transition-all duration-300 ease-in-out hover:z-50 hover:shadow-2xl'
                                    onClick={() => handleImageClick(index)}
                                >
                                    <img
                                        src={`/images/systems/${id1}${id2 ? '/' : ''}${id2 ? id2 : ''}/${item}.png`}
                                        className='h-full w-full object-cover group-hover:scale-105 transition-all duration-300'
                                        alt=""
                                    />
                                     <img src='/images/filigran-square.png' className='absolute top-0 left-0 w-full h-full object-cover '/> 
                                    <MagnifyingGlassComponent />
                                </div>
                            </motion.div>
                        ))}
                    </motion.div>




                    {id2 &&<div className='text-xs font-extralight mb-5 mt-20'>{t('projeler')}</div>}

                    <div className='grid md:grid-cols-2 grid-cols-1 gap-3'>
                        {projelerData.map((category, catIndex) =>
                            category.categoryItem
                                .filter(project => project.systems.includes(id1) || project.systems.includes(id2))
                                .map((project, projIndex) => (
                                    <Link to={`/projeler/${category.link}/${project.link}`} key={`${catIndex}-${projIndex}`}>
                                        <div className="cursor-pointer mb-8 group relative">
                                            <div className="relative">
                                                <img
                                                    src={`/images/projeler/${category.link}/${project.link}/1.jpg`}
                                                    className="aspect-video transition-all duration-300 object-cover w-full"
                                                    alt={project.title[currentLanguage]}
                                                />
                                                
                                                <div className='absolute top-0 left-0 bg-black z-10 h-full w-full opacity-0 group-hover:opacity-30 transition-all duration-300'></div>
                                                <img src='/images/filigran-rectangle.png' className='absolute top-0 left-0 w-full h-full object-cover '/> 
                                            </div>
                                            <div className="w-full flex justify-between items-center font-light text-20 pt-4 pb-4 relative">
                                                <h2>{project.title[currentLanguage]}</h2>
                                                <div className="h-7 w-7 flex justify-center items-center relative pr-6">
                                                    <div className="h-px absolute w-full bg-customGray"></div>
                                                    <div className="h-px absolute w-full bg-customGray rotate-90"></div>
                                                </div>
                                                <div className="h-px w-1/3 bg-customGray absolute bottom-0 left-0"></div>
                                            </div>
                                        </div>
                                    </Link>
                                ))
                        )}
                    </div>


                </div>
            </div>
        </motion.div>
    )
}

export default InnerSystemComponent;
